import { Link } from "react-router-dom";
import { Monitor } from "lucide-react";

const AppleLogo = ({ size }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="currentColor" aria-hidden="true">
    <path d="M16.37 12.6c-.02-2.3 1.88-3.4 1.96-3.46-1.07-1.56-2.73-1.78-3.32-1.8-1.41-.14-2.76.83-3.48.83-.72 0-1.82-.81-3-.79-1.54.02-2.96.9-3.76 2.27-1.6 2.78-.41 6.9 1.15 9.16.76 1.1 1.67 2.34 2.86 2.3 1.15-.05 1.58-.74 2.97-.74 1.39 0 1.78.74 2.99.72 1.24-.02 2.02-1.12 2.77-2.23.87-1.28 1.23-2.52 1.25-2.58-.03-.01-2.4-.92-2.42-3.66zM14.1 5.84c.63-.77 1.06-1.83.94-2.89-.91.04-2.02.61-2.67 1.37-.58.67-1.1 1.76-.96 2.8 1.02.08 2.06-.52 2.69-1.28z" />
  </svg>
);

const PlayLogo = ({ size }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" aria-hidden="true">
    <path d="M3.6 2.3 13.4 12l-9.8 9.7c-.35-.2-.6-.6-.6-1.1V3.4c0-.5.25-.9.6-1.1z" fill="#00D7FE" />
    <path d="m16.7 8.7-3.3 3.3-9.8-9.7c.3-.2.8-.2 1.2 0l11.9 6.4z" fill="#00F076" />
    <path d="m16.7 15.3-11.9 6.4c-.4.2-.9.2-1.2 0l9.8-9.7 3.3 3.3z" fill="#FF3A44" />
    <path d="m20.3 13.3-3.6 2-3.3-3.3 3.3-3.3 3.6 2c.9.5.9 2.1 0 2.6z" fill="#FFD400" />
  </svg>
);

const BOX = "rounded-2xl flex items-center justify-center hover:scale-[1.04] active:scale-[0.97] transition-transform";

/** Iconos de App Store, Google Play y acceso web. Usado en /pro, /register y /plan. */
export default function DownloadLinks({ lang = "es", compact = false }) {
  const isES = lang !== "en";
  const h = compact ? "h-20" : "h-24";
  const size = compact ? 36 : 42;
  return (
    <div className="grid grid-cols-3 gap-3" data-testid="download-links-block">
      <a href="https://apps.apple.com/es/app/id6803214279" target="_blank" rel="noopener noreferrer"
        className={`${BOX} ${h} bg-black text-white`} aria-label="App Store" title="App Store" data-testid="dl-link-ios">
        <AppleLogo size={size} />
      </a>
      <a href="https://play.google.com/store/apps/details?id=es.smileandshine.cleaning" target="_blank" rel="noopener noreferrer"
        className={`${BOX} ${h} bg-[#0F2A4D]`} aria-label="Google Play" title="Google Play" data-testid="dl-link-android">
        <PlayLogo size={size} />
      </a>
      <Link to="/login" className={`${BOX} ${h} bg-gradient-to-br from-[#FF7A50] to-[#F56038] text-white`}
        aria-label={isES ? "Escritorio" : "Desktop"} title={isES ? "Escritorio" : "Desktop"} data-testid="dl-link-desktop">
        <Monitor size={size} strokeWidth={1.8} />
      </Link>
    </div>
  );
}
